import convert from 'css-unit-converter';
import parseUnit from 'parse-unit';
import shave from 'shave';

const FALLBACK_LINE_HEIGHT = 1.5;
const FALLBACK_BASE_FONT_SIZE = 14;

const taskQueue = [];
let animationFrame = null;

const executeAllTasks = () => {
  let task;
  while (task = taskQueue.shift()) {
    shave(task.element, task.height, { spaces: false });
  }
};

/**
 * Handle the collection of tasks and put the tasks futher back into the
 * Browser's event queue for batch execution.
 */
const requestTask = (task) => {
  window.clearTimeout(animationFrame);
  taskQueue.push(task);
  animationFrame = window.setTimeout(executeAllTasks, 100);
};

const getMaxHeight = (element) => {
  const lineHeight = window.getComputedStyle(element).lineHeight; // This trigger relayout
  const [parsedValue, parsedUnit] = parseUnit(lineHeight);

  return (parsedUnit && parsedValue >= 0)
    ? convert(parsedValue, parsedUnit, 'px')
    : FALLBACK_LINE_HEIGHT * FALLBACK_BASE_FONT_SIZE
  ;
};

/**
 * An ellipse helper class that handle all the ellipse and truncating problems.
 * This class make use of the data-line-clamp / lineClamp attribute to determine
 * number of lines to clamp.
 *
 * |     Line clamp     |    Behaviour                                              |
 * |--------------------|-----------------------------------------------------------|
 * |     1              | Use CSS ellipse and skip the JS truncating method.        |
 * |  >= 2 (Webkit)     | Use webkit-lineclamp and remove the JS truncating method. |
 * |  >= 2 (non-webkit) | Use the JS truncating method.                             |
 *
 */
const truncateHelper = {
  truncate(element) {
    const numLines = parseInt(element.dataset.lineClamp, 10) || 2;
    if (numLines < 2) return;
    requestTask({
      element,
      height: getMaxHeight(element) * numLines,
    });
  },
  truncateMany(elements) {
    for (let i = 0; i < elements.length; i++) {
      truncateHelper.truncate(elements[i]);
    }
  },
};

// Remove truncate method for webkit browser.
if ('webkitLineClamp' in document.documentElement.style) {
  truncateHelper.truncate = () => { };
}

export default truncateHelper;
